/**
 * Tripjack Air Review session id — must match reviewSnapshot for /book (PDF v2.0).
 * Prefer bookingId/orderId inside the snapshot over stale navigation state.
 */

export function unwrapFunnelReviewSnapshot(snapshot) {
  if (!snapshot || typeof snapshot !== 'object') return null;
  const inner = snapshot.data;
  if (
    inner
    && typeof inner === 'object'
    && (
      inner.tripInfos != null
      || inner.searchResult != null
      || inner.bookingId
      || inner.orderId
    )
  ) {
    return inner;
  }
  return snapshot;
}

/** bookingId or orderId from review body; else optional fallback (e.g. state). */
export function tripjackSessionBookingId(reviewData, fallbackId = null) {
  const inner = unwrapFunnelReviewSnapshot(reviewData);
  if (!inner) {
    return fallbackId != null && fallbackId !== '' ? String(fallbackId) : null;
  }
  const bid = inner.bookingId || inner.orderId;
  if (bid != null && bid !== '') return String(bid);
  return fallbackId != null && fallbackId !== '' ? String(fallbackId) : null;
}
